class CollectionTabs extends HTMLElement {
  connectedCallback() {
    this.#tabs = [...this.querySelectorAll('[data-collection-tab]')];
    this.#panels = [...this.querySelectorAll('[data-collection-panel]')];

    if (!this.#tabs.length || !this.#panels.length) return;

    this.addEventListener('click', this.#handleClick);
    this.addEventListener('keydown', this.#handleKeydown);

    const selectedTab = this.#tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ?? this.#tabs[0];
    if (selectedTab) {
      this.#activateTab(selectedTab, false);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.removeEventListener('keydown', this.#handleKeydown);
  }

  #tabs = [];

  #panels = [];

  #handleClick = (event) => {
    const tab = event.target.closest?.('[data-collection-tab]');
    if (!tab || !this.contains(tab)) return;

    this.#activateTab(tab);
  };

  #handleKeydown = (event) => {
    const tab = event.target.closest?.('[data-collection-tab]');
    if (!tab || !this.contains(tab)) return;

    const index = this.#tabs.indexOf(tab);
    if (index === -1) return;

    let nextIndex = null;

    switch (event.key) {
      case 'ArrowLeft':
      case 'ArrowUp':
        nextIndex = (index - 1 + this.#tabs.length) % this.#tabs.length;
        break;
      case 'ArrowRight':
      case 'ArrowDown':
        nextIndex = (index + 1) % this.#tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.#tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    this.#activateTab(this.#tabs[nextIndex], true);
  };

  #activateTab(tab, focus = true) {
    const tabId = tab.getAttribute('aria-controls');
    if (!tabId) return;

    for (const currentTab of this.#tabs) {
      const isSelected = currentTab === tab;
      currentTab.setAttribute('aria-selected', String(isSelected));
      currentTab.tabIndex = isSelected ? 0 : -1;
    }

    for (const panel of this.#panels) {
      const isActive = panel.id === tabId;
      panel.hidden = !isActive;
      panel.setAttribute('aria-hidden', String(!isActive));
    }

    if (focus) tab.focus({ preventScroll: true });
  }
}

if (!customElements.get('collection-tabs')) {
  customElements.define('collection-tabs', CollectionTabs);
}
